import script from "./FaqConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqConfig.vue?vue&type=script&setup=true&lang=js"

import "./FaqConfig.vue?vue&type=style&index=0&id=7bd332b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd332b5"]])

export default __exports__